<template>
  <div class="achievement-analysis-class">
    <!-- 顶部选择条件和一些按钮 -->
    <achievementTopBar @classComparison="classComparison" @externalPerformanceComparison="externalPerformanceComparison"
      @classDimension="classDimension" @deriveClassGrades="deriveClassGrades" @back="back" />
    <achievementList @classAchievementChange="classAchievementChange" :examInfo="examInfo"
      :courseFullList="courseFullList" :gradeExamId="gradeExamId" />
    <!-- 成绩对比雷达图弹窗 -->
    <achievementChartDialog :chartType="chartType" v-if="chartDialogShow" :chartDialogShow.sync="chartDialogShow"
      :scoreClassContrastData="scoreClassContrastData" :courseFullList="courseFullList" :courseList="courseList"
      :classSelectList="classSelectList" :examInfo="examInfo" />
    <!-- 选择校外标识弹窗 -->
    <selectExternalDialog v-if="selectExternalDialogShow" :externalList="externalList"
      :selectExternalDialogShow.sync="selectExternalDialogShow"
      @selectExternalConfirm="externalPerformanceComparisonDialogShow" />
  </div>
</template>

<script>
import achievementTopBar from "./components/achievement-topBar/achievementTopBar.vue";
import achievementList from "./components/achievement-list/achievementList.vue";
import achievementChartDialog from "./components/achievement-chart-dialog/achievementChartDialog.vue";
import selectExternalDialog from "./components/select-external-dialog/selectExternalDialog.vue";
import { baseURL } from "@/api/request"; // 服务器地址
export default {
  components: {
    achievementTopBar,
    achievementList,
    achievementChartDialog,
    selectExternalDialog,
  },
  data() {
    return {
      classSelectList: [], // 选中的班级
      chartType: "", // chat显示类型
      chartDialogShow: false,
      examInfo: null,
      scoreClassContrastData: [], // 班级对比数据
      selectExternalDialogShow: false, // 选择校外标识弹窗
      externalList: [], // 校外标识列表
      courseList: [], // 对比科目列表
      courseFullList: [], // 分制列表
      gradeId: "",
      gradeExamId: "",
      gradeExamSearchData: null, // 年级考试搜索条件
    };
  },
  created() {
    let data = JSON.parse(this.$route.query.examInfo);
    data.forEach((item) => {
      item["gradeId"] = +this.$route.query.gradeId;
    });
    if (this.$route.query.searchData) {
      // 年级考试搜索条件
      this.gradeExamSearchData = JSON.parse(this.$route.query.searchData);
    };

    this.gradeExamId = +this.$route.query.gradeExamId;
    this.examInfo = data;
    this.getPointSystem(this.$route.query.gradeId);
    // console.log("this.examInfo:", this.examInfo);
  },
  methods: {
    // 返回
    back() {
      this.$router.push({
        path: "/achievement-analysis-grade",
        query: {
          searchData: JSON.stringify(this.gradeExamSearchData)
        },
      });
    },
    // 导出
    deriveClassGrades() {
      let action = `${baseURL}${this.$url.classExamInfoRankExcelPC}?id=${this.examInfo[0].id}`;
      window.open(action);
    },
    // 获取考试科目分制
    getPointSystem(e) {
      let data = {
        schoolId: this.user.schoolId,
        gradeId: e,
      };
      this.get(this.$url.getCourseFullList, data).then((res) => {
        // console.log("获取科目分制；", res);
        if (res.code !== 200)
          return this.$message.error(res.msg || "获取科目分制失败");
        this.courseFullList = res.rows;
      });
    },
    // 班级成绩对比
    classComparison(e) {
      if (!this.classSelectList.length) {
        return this.$message.warning("请先选择考试");
      }
      if (this.classSelectList.length < 2) {
        return this.$message.warning("至少选择两个班级考试");
      }
      let data = {
        examInfoId: this.examInfo[0].id,
        classIds: this.classSelectList,
      };
      this.post(this.$url.selectScoreClassContrast, data).then((res) => {
        // console.log("获取班级平均分对比：", res);
        if (res.code !== 200) return this.$message.error(res.msg);
        if (!res.data.length) return this.$message.warning("没有成绩数据");
        this.scoreClassContrastData = res.data;
        this.chartType = e;
        this.chartDialogShow = true;
      });
    },
    // 获取校外标识
    getExternalAchievementPC() {
      this.get(this.$url.getExternalAchievementPC, {
        gradeId: this.examInfo.gradeId,
        examInfoId: this.examInfo[0].id,
        schoolId: this.user.schoolId,
      }).then((res) => {
        // console.log("获取校外标识列表==>", res);
        if (res.code !== 200) return this.$message.error(res.msg);
        if (res.total === 0) return this.$message.warning("未录入校外成绩");
        this.externalList = res.rows;
        this.selectExternalDialogShow = true;
      });
    },
    // 校外成绩
    externalPerformanceComparison(e) {
      if (!this.classSelectList.length) {
        return this.$message.warning("请先选择考试");
      }
      // if (this.classSelectList.length > 1) {
      //   return this.$message.warning("只能选择一个班级考试");
      // }
      this.chartType = e;
      this.getExternalAchievementPC();
    },
    // 选择完对比的校外标识后点击下一步
    externalPerformanceComparisonDialogShow(e) {
      let data = {
        classIds: this.classSelectList,
        examInfoId: this.examInfo[0].id,
        outsideSchoolSign: e,
      };
      this.post(this.$url.selectScoreClassExtramuralContrast, data).then(
        (res) => {
          // console.log("获取单个班级和校外平均分对比", res);
          if (res.code !== 200) return this.$message.error(res.msg);
          this.scoreClassContrastData = res.data;
          this.chartDialogShow = true;
          this.selectExternalDialogShow = false;
        }
      );
    },
    // 班级维度
    classDimension(e) {
      if (!this.classSelectList.length) {
        return this.$message.warning("请先选择班级考试");
      }
      let data = {
        examInfoId: this.examInfo[0].id,
        classIds: this.classSelectList,
      };
      this.post(this.$url.classExamInLatitudeContrast, data).then((res) => {
        // console.log("获取班级成绩纬度对比", res);
        if (res.code !== 200) return this.$message.error(res.msg);
        res.data.forEach((item) => {
          item.examInfoLatitudePCDTOS.forEach((cItem) => {
            if (!this.courseList.includes(cItem.courseName)) {
              this.courseList.push(cItem.courseName);
            }
          });
        });
        this.scoreClassContrastData = res.data;
        this.chartType = e;
        this.chartDialogShow = true;
      });
    },
    // 选中的班级
    classAchievementChange(e) {
      this.classSelectList = e;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./achievementAnalysisClass.scss";
</style>